<template>
  <layout-default>
    <span slot="title">Users</span>
    <router-link
      to="/user/0"
      class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-gray-400 hover:bg-gray-500 focus:outline-none focus:shadow-outline-gray focus:border-gray-700 active:bg-gray-700"
    >
      <font-awesome-icon :icon="['fad', 'user-plus']" size="lg" />
    </router-link>
    <ul class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-4">
      <li
        v-for="user in users"
        :key="user.id"
        class="col-span-1 bg-white rounded-lg shadow"
      >
        <div class="w-full flex items-center justify-between p-6 space-x-6">
          <div class="flex-1 truncate">
            <div class="flex items-center space-x-3">
              <h3 class="text-gray-900 text-sm leading-5 font-medium truncate">
                {{ user.first }} {{ user.last }}
              </h3>
            </div>
            <p class="mt-1 text-gray-500 text-sm leading-5 truncate">
              {{ user.email }}
            </p>
          </div>
        </div>
        <div class="border-t border-gray-200">
          <div class="-mt-px flex">
            <div class="w-0 flex-1 flex border-r border-gray-200">
              <router-link
                :to="'user/' + user.id"
                class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-150"
              >
                <font-awesome-icon
                  :icon="['fad', 'user-edit']"
                ></font-awesome-icon>
                <span class="ml-3">Edit</span>
              </router-link>
            </div>
            <div class="-ml-px w-0 flex-1 flex">
              <a
                href="#"
                class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-150"
              >
                <font-awesome-icon
                  :icon="['fad', 'user-times']"
                ></font-awesome-icon>
                <span class="ml-3">Delete</span>
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <router-view></router-view>
  </layout-default>
</template>

<script>
import LayoutDefault from "@/components/layouts/LayoutDefault.vue";
export default {
  name: "Users",
  components: {
    LayoutDefault
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    users() {
      return this.$store.state.users;
    }
  },
  created() {
    if (this.isAdmin) {
      this.$store.dispatch("getUsers");
    }
  }
};
</script>
